import { render, staticRenderFns } from "./consultAstrologyPage.vue?vue&type=template&id=f196acc4&scoped=true"
import script from "./consultAstrologyPage.vue?vue&type=script&lang=js"
export * from "./consultAstrologyPage.vue?vue&type=script&lang=js"
import style0 from "./consultAstrologyPage.vue?vue&type=style&index=0&id=f196acc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f196acc4",
  null
  
)

export default component.exports